import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Blocks from "@/pages/Blocks";
import Transactions from "@/pages/Transactions";
import BlockDetail from "@/pages/BlockDetail";
import TxDetail from "@/pages/TxDetail";
import AddressDetail from "@/pages/AddressDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminLogs from "@/pages/AdminLogs";
import Tokens from "@/pages/Tokens";
import TokenDetail from "@/pages/TokenDetail";
import ApiDocs from "@/pages/ApiDocs";
import VerifyContract from "@/pages/VerifyContract";
import Accounts from "@/pages/Accounts";
import Contracts from "@/pages/Contracts";
import Charts from "@/pages/Charts";
import Nfts from "@/pages/Nfts";
import Rpc from "@/pages/Rpc";
import Newsletter from "@/pages/Newsletter";
import NotFound from "@/pages/NotFound";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blocks" element={<Blocks />} />
          <Route path="/txs" element={<Transactions />} />
          <Route path="/block/:number" element={<BlockDetail />} />
          <Route path="/tx/:hash" element={<TxDetail />} />
          <Route path="/address/:address" element={<AddressDetail />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/logs" element={<AdminLogs />} />
          <Route path="/tokens" element={<Tokens />} />
          <Route path="/token/:contract" element={<TokenDetail />} />
          <Route path="/api-docs" element={<ApiDocs />} />
          <Route path="/verify-contract" element={<VerifyContract />} />
          <Route path="/accounts" element={<Accounts />} />
          <Route path="/contracts" element={<Contracts />} />
          <Route path="/charts" element={<Charts />} />
          <Route path="/nfts" element={<Nfts />} />
          <Route path="/rpc" element={<Rpc />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
